import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PROJECT_STATE_TAG_TRANSLATION_KEY } from "../constants";
export default /*#__PURE__*/_defineProperty({}, PROJECT_STATE_TAG_TRANSLATION_KEY, {
  PARTICIPATION_PROJECT: 'Proyecto de participación',
  FREE_COURSE: 'Curso gratis',
  DRAFT: 'Borrador',
  PUBLISHED: 'En revisión',
  OBSERVED: 'Con observaciones',
  CERTIFIED: 'Certificado',
  APPROVED: 'Aprobado',
  FINISHED: 'Completado',
  EXPIRED: 'Fuera de tiempo',
  TEACHER_PROJECT: 'Proyecto del profesor'
});